import { ManagementScheduleExecutionRepository } from '@domain/management-schedule-execution/repositories/management-schedule-execution.repository';
import { ManagementScheduleExecutionRepositoryService } from '../repositories/management-schedule-execution.service';

export const ManagementScheduleExecutionProvider = [
  {
    provide: ManagementScheduleExecutionRepository,
    useClass: ManagementScheduleExecutionRepositoryService,
  },
];
